import Vue from "vue"
import Vuex from "vuex"
 
Vue.use(Vuex);
 
export default new Vuex.Store({
    state:{
        token:"",
    },
    mutations:{
        // 保存当前菜单栏的路径
        SET_TOKEN(state,token){
            state.token = token;
        },
    }
})